import React from 'react';
import PropTypes from 'prop-types';
import KpiSummary from '../../../commons/KpiSummary';

const StudentAccessFrequencySummary = (props) => (
  <KpiSummary
    title="Access Count"
    isLoading={props.isLoading}
    currentValue={props.currentValue}
    previousValue={props.previousValue}
    standardDeviationValue={props.standardDeviationValue}
    formatter={props.formatter}
  />
);

StudentAccessFrequencySummary.propTypes = {
  isLoading: PropTypes.bool,
  currentValue: PropTypes.string.isRequired,
  previousValue: PropTypes.string.isRequired,
  formatter: PropTypes.func.isRequired,
};

StudentAccessFrequencySummary.defaultProps = {
  isLoading: false,
};

export default StudentAccessFrequencySummary;
